const InitialFormValues = {
  facilityName: "",
  facilityAlias: "",
  facilityActive: {},
  facilityInactiveDate: null,
  facilityUSEPA: {},
  facilityEPAIDType: {},
  facilityMediaType: {},
  facilityEPAID: "",
  facilityFEIN: "",
  facilityBOENumber: "",
  locationStreet1: "",
  locationStreet2: "",
  locationCity: "",
  locationState: { value: "CA", label: "CA" },
  locationZip: "",
  locationCounty: {},
  locationRegion: {},
  locationCUPA: {},
  mailingAttention: "",
  mailingStreet1: "",
  mailingStreet2: "",
  mailingState: {},
  mailingCity: "",
  mailingZip: "",
  contactName: "",
  contactStreet1: "",
  contactStreet2: "",
  contactState: {},
  contactCity: "",
  contactZip: "",
  contactPhone: "",
  contactPhoneExt: "",
  contactFax: "",
  contactMedia: {},
  contactEmail: "",
  ownerName: "",
  ownerStreet1: "",
  ownerStreet2: "",
  ownerState: {},
  ownerCity: "",
  ownerZip: "",
  ownerPhone: "",
  ownerPhoneExt: "",
  ownerFax: "",
  callerBusiness: "",
  callerName: "",
  callerStreet1: "",
  callerStreet2: "",
  callerState: {},
  callerCity: "",
  callerZip: "",
  callerPhone: "",
  callerPhoneExt: "",
  callerFax: "",
  callerEmail: "",
  facilityComments: "",
  facilityNaics: [],
  facilityTypes: [],
  startDate: null,
  endDate: null,
  focused: false,
  requestorType: {},
};

export default InitialFormValues;
